/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-09-09 16:25:52
 * @LastEditors: voanit
 * @LastEditTime: 2021-12-10 14:22:49
 */
export default [
  {
    path: '/day-report',
    name: 'day-report',
    meta: {
      name: '经营日报',
      keepAlive: true,
      notLayout: true
    },
    component: () => import(/* webpackChunkName: "analysis" */ '@/views/operate-analysis/day-report/index.vue')
  },
  {
    path: '/month-report',
    name: 'month-report',
    meta: {
      name: '经营月报',
      keepAlive: true,
      notLayout: true
    },
    component: () => import(/* webpackChunkName: "analysis" */'@/views/operate-analysis/month-report/index.vue')
  },
  {
    path: '/order-analysis',
    name: 'order-analysis',
    meta: {
      name: '订单分析',
      keepAlive: true,
      notLayout: true
    },
    component: () => import(/* webpackChunkName: "analysis" */'@/views/operate-analysis/order-analysis/index.vue')
  },

]
